import styled, { css } from 'styled-components';
import { rem } from 'polished';

import { Row } from '../../base/Grid';

export const SwiperCarouselContainerRow = styled(Row)`
  width: 100%;
  height: 100%;
  padding-bottom: ${rem('40px')};
`

export const SwiperCarouselSwiperSlide = styled.div`
  display: flex;
  // width: 100%; // TODO: swiper-slide needs to be set to 100%? figure out if Storybook is messing with width or if this is working fine outside of storyBook
  justify-content: center;
`

export const SwiperCarouselSwiperPagination = styled.div`
  width: 100%;
  bottom: 0;
`

export const SwiperCarouselSwiperNavigation = styled.div`
  ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    return css`
      top: ${rem('130px')}; // need nmx-template Sass values here.
      top: ${smallUp ? '50%' : rem('130px')};
      &::after {
        color: ${theme.colors.neutral.grey41};
      }
    `
  }}
`
